import * as Sentry from "@sentry/react";

// Sentry configuration with development filtering
export const initSentry = () => {
  // Only initialize Sentry if DSN is provided
  const sentryDsn = process.env.REACT_APP_SENTRY_DSN;

  if (!sentryDsn) {
    console.warn("Sentry DSN not provided. Error tracking disabled.");
    return;
  }

  Sentry.init({
    dsn: sentryDsn,
    environment: process.env.NODE_ENV,
    enableLogs: true,
    // Set tracesSampleRate based on environment
    tracesSampleRate: process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE
      ? parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE)
      : process.env.NODE_ENV === "production"
      ? 0.1
      : 1.0,
    // Set profilesSampleRate based on environment
    profilesSampleRate: process.env.REACT_APP_SENTRY_PROFILES_SAMPLE_RATE
      ? parseFloat(process.env.REACT_APP_SENTRY_PROFILES_SAMPLE_RATE)
      : process.env.NODE_ENV === "production"
      ? 0.1
      : 1.0,
    // Filter out development errors to save quota
    beforeSend(event, hint) {
      // Only send events in production or when explicitly testing
      if (process.env.NODE_ENV === "development") {
        // Check if this is a test error (from our test components)
        const isTestError =
          event.tags?.test === true ||
          event.extra?.test === true ||
          event.exception?.values?.[0]?.value?.includes(
            "test error for Sentry monitoring"
          ) ||
          event.message?.includes("test message from SentryTest component");

        // Only send test errors in development
        if (isTestError) {
          return event;
        }

        // Block all other development errors
        return null;
      }

      // Send all events in production
      return event;
    },
    // Filter out development logs as well
    beforeSendTransaction(event) {
      // Only send transactions in production
      if (process.env.NODE_ENV === "development") {
        return null;
      }
      return event;
    },
  });
};
